<template>
    <Head title="Galeria de Fotos" />
    <Authenticated>
        <Heading title="Galeria de Fotos" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div class="component-background-desktop min-h-[70vh]">
            <div class="px-2.5 py-[35px] xl:px-[15vw]">
                <p>
                    Selecione nos filtros por período de upload, por campanhas,
                    lojas, região e execução.
                </p>
                <div class="flex items-center gap-x-4" :class="{'pointer-events-none' : isLoading}">
                    <FilterGalleriesV2
                        :participants="participants"
                        :subregions="subregions"
                        :contests="contests"
                        :regions="regions"
                        :pdvs="pdvs"
                        :categories="categories"
                        :subcategories="subcategories"
                        @sendFilter="sendFilter()"
                        @clearFilter="clearFilter()"
                        v-model="formFilter"
                    />
                    <a
                        v-if="isFiltered"
                        class="text-blue-600 hover:underline cursor-pointer text-sm"
                        @click="clearFilterAndFetchGalleries()"
                        >Limpar Filtro</a
                    >
                    <span v-if="isLoading">Aguarde...</span>
                </div>
                <section
                    class="relative flex flex-wrap justify-start gap-x-2 gap-y-8 mt-4"
                >
                    <Loading
                        :active="isLoading"
                        :is-full-page="false"
                        :z-index="10"
                    />
                    <div
                        class="border border-primary bg-white rounded-2xl p-4 w-full xl:w-[395px]"
                        v-for="(item) in computedGalleries"
                        :key="item.id"
                    >
                        <div>
                            <Carousel :photos="item.pictures" />
                            <div class="relative">
                                <div
                                    class="absolute right-4 bottom-4 cursor-pointer hover:bg-white"
                                    @click="showInModal(item.pictures)"
                                >
                                    <Icon name="Expandir" />
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 flex justify-between gap-x-4">
                            <div class="flex flex-col gap-y-3">
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Participante
                                    </h1>
                                    <p @click="handleShowParticipantsModal(item.participants)" class="cursor-pointer hover:underline hover:text-blue-500">{{ item.userCreated?.name }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Regional / Sub-regional
                                    </h1>
                                    <p>
                                        {{ item.pdv?.region }} /
                                        {{ item.pdv?.subregion.name }}
                                    </p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Quantidade de Fotos
                                    </h1>
                                    <p>{{ item.pictures?.length || 0 }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Data do Upload
                                    </h1>
                                    <p>{{ formatDataBR(item.createdAt) }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Senha Semanal
                                    </h1>
                                    <p>{{ getWeeklypassphrase(item.createdAt) }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Status
                                    </h1>
                                    <p
                                        v-if="item.validation?.status === 'A'"
                                        class="py-4 px-3 border rounded-2xl text-center bg-green-200 border-success"
                                    >
                                        Enviada
                                    </p>
                                    <p
                                        v-if="item.validation?.status === 'R'"
                                        class="py-4 px-3 border rounded-2xl text-center bg-red-200 border-error"
                                    >
                                        Reprovada
                                    </p>
                                    <p
                                        v-if="
                                            ['A', 'R'].indexOf(
                                                item.validation?.status
                                            ) < 0
                                        "
                                        class="py-4 px-3 border rounded-2xl text-center bg-green-200 border-success"
                                    >
                                        Enviada
                                    </p>
                                    <div
                                        @click="
                                            currentReason =
                                                item.validation.denyReason
                                        "
                                        class="text-blue-600 hover:underline cursor-pointer mt-2"
                                        v-bind:class="{
                                            hidden:
                                                item.validation?.status !== 'R',
                                        }"
                                    >
                                        Saiba o motivo
                                    </div>
                                </div>
                                <div v-if="item.shelfpixStatus">
                                    <h1 class="text-primary font-bold">
                                        Auditoria IA
                                    </h1>
                                    <p
                                        v-if="item.shelfpixStatus === 'APROVADA'"
                                        class="py-4 px-3 border rounded-2xl text-center bg-green-200 border-success"
                                    >
                                        IA: Aprovada
                                    </p>
                                    <template v-else>
                                        <p
                                            class="py-4 px-3 border rounded-2xl text-center bg-red-200 border-error"
                                        >
                                            IA: Reprovada
                                        </p>
                                        <div
                                            v-if="item.shelfpixMotivoReprovacao"
                                            @click="openShelfpixModal(item.shelfpixMotivoReprovacao)"
                                            class="mt-2 cursor-pointer"
                                        >
                                            <div class="flex flex-wrap gap-1.5">
                                                <span
                                                    v-for="(reason, idx) in parseShelfpixReasons(item.shelfpixMotivoReprovacao)"
                                                    :key="idx"
                                                    class="inline-flex items-center text-xs font-semibold px-2 py-1 rounded-full"
                                                    :class="chipToneClass(reason.tone)"
                                                >
                                                    {{ reason.label }}
                                                </span>
                                            </div>
                                            <p class="text-xs text-blue-600 hover:underline mt-1">
                                                Toque para ver detalhes
                                            </p>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="flex flex-col gap-y-3 text-left">
                                <div>
                                    <h1 class="text-primary font-bold">Sold</h1>
                                    <p>{{ item.pdv?.codeSoldBroker }}</p>
                                </div>
                                <div>
                                    <h1
                                        class="text-primary font-bold whitespace-nowrap"
                                    >
                                        Tipo de Execução
                                    </h1>
                                    <p>{{ item.executionType?.description }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Campanha
                                    </h1>
                                    <p>{{ item.contest?.name }}</p>
                                </div>
                                <!-- <div>
                                    <h1 class="text-primary font-bold">
                                        Categoria
                                    </h1>
                                    <p>{{ item.contestcategory?.group }}</p>
                                </div> -->
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Categoria
                                    </h1>
                                    <p v-if="item.categories?.length === 0">NÃO ENCONTRADO</p>
                                    <p v-for="(category, key) in handleCategories(item.categories)" :key="key">{{ category }}</p>
                                </div>
                                <div>
                                    <h1 class="text-primary font-bold">
                                        Subcategoria
                                    </h1>
                                    <p v-if="item.categories?.length === 0">NÃO ENCONTRADO</p>
                                    <p v-for="(subcategory, key) in handleSubcategories(item.categories)" :key="key">{{ subcategory }}</p>
                                </div>
                                <div class="flex flex-col">
                                    <h1 class="text-primary font-bold">
                                        Baixar galeria
                                    </h1>
                                    <ZipButton :zipName="item.id" :fileNames="getFileNames(item.pictures)"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <pagination :total="pagination.total" :limit="pagination.limit" @page:selected="setPage($event)"/>
            </div>
        </div>

        <transition v-if="$page.props.flash.error || $page.props.flash.success">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4"
                >
                    <button class="float-right" @click="$page.props.flash = ''">
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        {{ $page.props.flash.success ? "Sucesso" : "Erro" }}
                    </h1>
                    <p class="mt-2.5">
                        {{
                            $page.props.flash.success
                                ? $page.props.flash.success
                                : $page.props.flash.error
                        }}
                    </p>
                </div>
            </div>
        </transition>
        <transition v-if="currentReason">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="relative bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4 flex flex-col"
                >
                    <button
                        class="absolute top-2 right-2"
                        @click="currentReason = ''"
                    >
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        Possível motivo
                    </h1>
                    <p class="mt-2.5 break-words">{{ currentReason }}</p>
                    <button
                        class="transition-all self-center max-w-[94px] mt-2 p-4 bg-white border border-primary rounded-2xl font-bold text-primary hover:bg-gray-300 hover:border-gray-300"
                        @click="currentReason = ''"
                    >
                        Entendi
                    </button>
                </div>
            </div>
        </transition>
        <transition v-if="shelfpixModal.open">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="relative bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4 flex flex-col"
                >
                    <button
                        class="absolute top-2 right-2"
                        @click="shelfpixModal.open = false"
                    >
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        Por que a IA reprovou
                    </h1>
                    <ul class="mt-2.5 flex flex-col gap-3">
                        <li
                            v-for="(reason, idx) in shelfpixModal.reasons"
                            :key="idx"
                            class="flex flex-col"
                        >
                            <span
                                class="inline-flex self-start items-center text-xs font-semibold px-2 py-1 rounded-full"
                                :class="chipToneClass(reason.tone)"
                            >
                                {{ reason.label }}
                            </span>
                            <p
                                v-if="reason.raw && reason.raw !== reason.label"
                                class="text-sm text-gray-600 mt-1 break-words"
                            >
                                {{ reason.raw }}
                            </p>
                        </li>
                    </ul>
                    <button
                        class="transition-all self-center mt-4 px-6 py-3 bg-white border border-primary rounded-2xl font-bold text-primary hover:bg-gray-300 hover:border-gray-300"
                        @click="shelfpixModal.open = false"
                    >
                        Entendi
                    </button>
                </div>
            </div>
        </transition>
        <transition v-if="showParticipantModal">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-[4px] px-4 py-4 relative"
                >
                    <button class="absolute top-2 right-2" @click="showParticipantModal = false">
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        Colaboradores da execução
                    </h1>
                    <ul class="uppercase">
                        <li v-for="(galleryParticipant, key) in participantsToShowInModal" :key="key">{{galleryParticipant.participant?.name}}</li>
                    </ul>
                </div>
            </div>
        </transition>
        <Gallery :gallery="currentGallery" />
    </Authenticated>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Pagination from "@/Components/UI/Pagination.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import Gallery from "@/Components/Gallery.vue";
import Carousel from "@/Components/CarouselSimple.vue";
import FilterGalleriesV2 from "@/Components/Filters/FilterGalleriesV2.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import ZipButton from "@/Components/Download/ZipButton.vue";
import {formatFileApiUrlToFileName} from "@/Helpers/formatters"


export default {
    components: {
        Authenticated,
        Head,
        Heading,
        Head,
        Icon,
        Button,
        Gallery,
        Carousel,
        FilterGalleriesV2,
        Pagination,
        Loading,
        ZipButton,
    },

    props: {
        contests: Object,
        firstGalleries: Object,
        total: Number,
        pdvs: Object,
        regions: Object,
        subregions: Object,
        categories: Object,
        subcategories: Object,
        participants: Object,
        weeklypassphrases: Object
    },

    data() {
        return {
            galleries: this.firstGalleries,
            pagination: {
                total: this.total,
                limit: 12,
            },
            isFiltered: false,
            isLoading: false,
            isLoadingPage: [],
            currentGallery: null,
            executions: [],
            title: "-",
            currentInput: "",
            currentReason: "",
            controller: new AbortController(),
            showParticipantModal: false,
            participantsToShowInModal: [],
            shelfpixModal: { open: false, reasons: [] },
            formFilter: this.getInitialFormFilterValue(),
            lastFormFilter: {}
        };
    },

    computed: {
        computedGalleries() {
            return this.galleries;
        },
        isLoading() {
            return this.isLoadingPage?.length > 0;
        }
    },

    methods: {
        // Maps each raw ShelfPix reason to a participant-friendly chip.
        // The vocabulary is small (3 reasons); unknown reasons fall back to the raw text.
        parseShelfpixReasons(motivo) {
            if (!motivo) return [];
            const MAP = {
                "dados insuficientes para reconhecimento da categoria": {
                    label: "Produto não identificado",
                    tone: "amber",
                },
                "reconhecimento parcial de leitura": {
                    label: "Texto pouco legível",
                    tone: "blue",
                },
                "reprovada por perspectiva ou qualidade da foto": {
                    label: "Ângulo/qualidade da foto",
                    tone: "red",
                },
            };
            const seen = new Set();
            return motivo
                .split(/\s*[;,]\s*/)
                .map((reason) => reason.trim())
                .filter((reason) => {
                    const key = reason.toLowerCase();
                    if (!reason || seen.has(key)) return false;
                    seen.add(key);
                    return true;
                })
                .map((raw) => ({
                    raw,
                    ...(MAP[raw.toLowerCase()] || { label: raw, tone: "gray" }),
                }));
        },
        // Full literal class strings (purge-safe) per tone.
        chipToneClass(tone) {
            return (
                {
                    amber: "bg-yellow-100 text-yellow-800 border border-yellow-300",
                    blue: "bg-blue-100 text-blue-800 border border-blue-300",
                    red: "bg-red-100 text-red-800 border border-red-300",
                    gray: "bg-gray-100 text-gray-700 border border-gray-300",
                }[tone] || "bg-gray-100 text-gray-700 border border-gray-300"
            );
        },
        openShelfpixModal(motivo) {
            this.shelfpixModal = {
                open: true,
                reasons: this.parseShelfpixReasons(motivo),
            };
        },
        setPage(page) {
            this.currentPage = page;
            this.fetchGalleries({
                ...this.lastFormFilter,
                limit: this.pagination.limit,
                page: page,
            });
        },
        formatDataBR(data) {
            const options = {
                year: "numeric",
                month: "long",
                day: "numeric",
            };

            let d = new Date(data);
            d = moment(data).format("DD/MM/YYYY");

            return d;
        },
        sendFilter() {
            this.fetchGalleries(this.formFilter);
            this.lastFormFilter = {...this.formFilter};
        },
        fetchGalleries(data, isClear = false) {
            const requestId = new Date().getTime();
            this.isLoadingPage = this.isLoadingPage.filter(
                (isLoadingObject) => isLoadingObject.requestId > requestId
            );
            this.isLoadingPage.push({
                requestId,
                loading: true,
            });

            const dataPost = {...data};
            dataPost.contestId = dataPost.contest?.id;

            dataPost.channel = !dataPost.pdv && dataPost.channel?.name;
            dataPost.subchannel = !dataPost.pdv && dataPost.subchannel?.name;
            dataPost.customer = !dataPost.pdv && dataPost.customer?.name;
            dataPost.pdvNameLike = !dataPost.pdv?.id && dataPost.pdvNameLike;
            dataPost.pdvId = dataPost.pdv?.id;

            dataPost.participantId = dataPost.participant?.id;
            dataPost.status = dataPost.status?.id;
            dataPost.execution = dataPost.execution?.id;

            dataPost.regions = dataPost.subregions?.length === 0 ? dataPost.regions?.map(({id}) => id) : [];
            dataPost.subregions = dataPost.subregions?.map(({id}) => id);

            dataPost.category = !dataPost.subcategory && dataPost.category?.name;
            dataPost.subcategory = dataPost.subcategory?.id;

            axios.post("gallery/filter", dataPost).then((response) => {
                const lastRequest = this.isLoadingPage.find(
                    (isLoadingObject) => isLoadingObject.requestId === requestId
                );
                if (lastRequest) {
                    this.isLoadingPage = [];
                    this.galleries = response?.data.galleries;
                    if (response?.data.total >= 0) {
                        this.pagination.total = response?.data.total;
                    }

                    if (response.status == 200 && !isClear) {
                        this.isFiltered = true;
                    }
                }
            }).catch((err) => {
                console.log(err);
            })
        },
        clearFilterAndFetchGalleries() {
            this.clearFilter();
            this.fetchGalleries(this.formFilter, true);
        },
        clearFilter() {
            this.formFilter = this.getInitialFormFilterValue();
            this.isFiltered = false;
        },
        showInModal(photos) {
            this.currentGallery = {
                exhibition: photos[0],
                photos: photos,
            };
        },
        getWeeklypassphrase(createdAt) {
            const getOnlyDate = function(date) {
                return moment(date).format('YYYY-MM-DD');
            };

            const createdDate = getOnlyDate(createdAt);

            const weeklypassphraseFiltered = this.weeklypassphrases.filter(el => getOnlyDate(el.startDate) <= createdDate && getOnlyDate(el.endDate) >= createdDate);
            const hasWeeklypassphrase = weeklypassphraseFiltered.length > 0;

            if(hasWeeklypassphrase) {
                return weeklypassphraseFiltered[0].passphrase;
            }

            return 'N/A';
        },
        handleCategories(categories) {
            if(!categories) {
                return []
            }

            return categories?.reduce((previous, current) => {
                if(previous.find((el) => el === current.group) === undefined) {
                    previous.push(current.group);
                }
                return previous;
            }, []);
        },
        handleSubcategories(categories) {
            return categories.map(el => el.description)
        },
        getFileNames(picturesUrl) {
            return picturesUrl.map(pictureUrl => {
                return formatFileApiUrlToFileName(pictureUrl);
            })
        },
        handleShowParticipantsModal(participants) {
            this.participantsToShowInModal = participants;
            this.showParticipantModal = true;
        },
        getInitialFormFilterValue() {
            return {
                startDate: "",
                endDate: "",
                participant: "",
                contest: "",
                category: "",
                subcategory: "",
                channel: "",
                subchannel: "",
                customer: "",
                pdv: "",
                pdvNameLike: "",
                regions: [],
                subregions: [],
                execution: "",
                status: "",
            }
        }
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
